var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("checkout:payment.info.title")))]),
    _vm._v(" "),
    _c("div", { staticClass: "benefits-images" }, [
      _c(
        "ul",
        { staticClass: "payment-logos" },
        [
          _c("li", { staticClass: "payment-logos__item" }, [
            _c("img", {
              attrs: {
                src: _vm.$asset.image("payment/methods/scheme.svg"),
                alt: "",
              },
            }),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "payment-logos__item" }, [
            _c("img", {
              attrs: {
                src: _vm.$asset.image("payment/methods/paypal.svg"),
                alt: "",
              },
            }),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "payment-logos__item" }, [
            _c("img", {
              attrs: {
                src: _vm.$asset.image("payment/methods/paysafecard.svg"),
                alt: "",
              },
            }),
          ]),
          _vm._v(" "),
          _vm.$api.data.region.shortName === "EU"
            ? [
                _c("li", { staticClass: "payment-logos__item" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.$asset.image("payment/methods/sofort.svg"),
                      alt: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "payment-logos__item" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.$asset.image("payment/methods/ideal.svg"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.$api.data.region.shortName === "US"
            ? [
                _c("li", { staticClass: "payment-logos__item" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.$asset.image("payment/methods/wechatpayqr.svg"),
                      alt: "",
                    },
                  }),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }